export const getDataCep = (state) => state.cepData